<template>
  <Wrapper>
    <Header />
    <Content />
    <Footer />
    <DebugApp :debugURL="debugURL" />
  </Wrapper>
</template>

<script lang="ts">
import DebugApp from "@fresh8/debug-kit/src/App.vue";
import { defineComponent, ref, watchEffect } from "vue";
import * as Sentry from "@sentry/browser";

import Wrapper from "./components/Wrapper.vue";
import Header from "./components/Header.vue";
import Footer from "./components/Footer.vue";
import Content from "./components/Content.vue";
import { AnalyticEvents } from "@fresh8/types/src/analytics";

import {
  createLayoutContext,
  provideLayoutSync
} from "@fresh8/vue-utils/src/dimensionSync";

import { installFonts } from "@fresh8/vue-utils/src/installFonts";
import { useHandleAnalytics } from "./lib/analytics";
import { useNoEvents } from "./hooks/useNoEvents";
import Properties from "./properties";
import { injectBetData } from "@fresh8/ad-data-composition/src/betData";
import { useAnalytics } from "./hooks/useAnalytics";
import { injectDisplayEvents } from "./composition/displayEvents";

export default defineComponent({
  components: {
    Wrapper,
    Header,
    Content,
    Footer,
    DebugApp
  },
  setup() {
    const $handleAnalytics = useHandleAnalytics();
    installFonts();
    provideLayoutSync(createLayoutContext());
    useNoEvents();
    const { firstThreeMarketIds } = injectDisplayEvents();
    const resivedVisbileEvent = ref(false);

    const { handleViewed } = useAnalytics({}, "Impression");

    handleViewed(firstThreeMarketIds.value);

    window.addEventListener(
      "message",
      e => {
        if (e.data.type === "ad_visible" && !resivedVisbileEvent.value) {
          resivedVisbileEvent.value = true;
          $handleAnalytics(AnalyticEvents.VIEWABLE, "Impression");
          window.parent.postMessage({ type: "f8_stop_visible" }, "*");
        }
      },
      true
    );

    const betData = injectBetData();

    watchEffect(() => {
      Sentry.configureScope(scope => {
        scope.setTag("catalogId", betData?.catalogId.value);
        scope.setTag("campaignId", betData?.campaignId.value);
        scope.setTag("viewId", betData?.viewId.value);
        scope.setTag("brandId", betData?.brandId.value);
      });
    });

    return {
      debugURL: Properties.debugUri
    };
  }
});
</script>

<style></style>
